import React from 'react'
import { branch, renderComponent } from 'recompose'

import Spinner from '../components/Spinner'

const LoadingText = () => <span>...</span>

const withLoadingState = (
  queryName,
  loadingComponent = 'spinner',
  customLoadingComponent
) =>
  branch(({ data }) => {
    if (data.loading) {
      const alreadyHasData = queryName in data
      return !alreadyHasData
    }
    return data.loading
  }, renderComponent(customLoadingComponent ? customLoadingComponent : loadingComponent === 'spinner' ? Spinner : LoadingText))

export default withLoadingState



// WEBPACK FOOTER //
// ./src/hocs/withLoadingState.js